import React, { Component } from 'react'
import "./ReportView.scss"
import ReportDetailContainer from './ReportDetailContainer/ReportDetailContainer'
import ReportUserContainer from './ReportDetailContainer/ReportUserContainer'
import ReportDtmfContainer from './ReportDetailContainer/ReportDtmfContainer'
import AuditDetailContainer from './ReportDetailContainer/AuditDetailContainer'
import LossDetailContainer from './ReportDetailContainer/LossDetailContainer'
import { ApolloProvider } from "react-apollo";
import { Query } from "react-apollo";
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';

import gql from "graphql-tag";
import { Modal, Spinner } from "office-ui-fabric-react";
import { toast } from "react-toastify";
import { MyContext } from '../../context';
import CaseManagementContainer from './ReportDetailContainer/CaseManagmentContainer'

export default class ReportView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isPanelOpen: false,
            loading: true,
            id: null
        }
    }

    renderData = (input, project, apol) => (
        <Query
            query={gql`

        query ent ($input: AuthInput, $project : String!) {
          getReportDetails (input: $input, reportId: $project) {
            id
            title
            widget
            type
            kpi
            startDate
            endDate
            valueType
            categories
            cycle
            overflow
            pstnNumber
            dtmfStartDate
            dtmfEndDate
            auditEvents {
                id
                name
                key
                created
                createdMs
                userId
                tenantId
                title
                group
                conversationId
                scenarioId
                text
                idType
                userLogin
                details
                recordingOwner
            }
            dtmfEntries{
                id
                tenantId
                pstnNumber
                creationDate
                endDate
            }
            groupedEntries{
                groupName
                reportEntries{
                    callStartMs
                    day
                    timein
                    conversationId
                    day
                    id
                    topic
                    recordingType
                    speech2Text
                    duration
                    timeout
                    notes
                    mediaAssets
                    mediaAssetVideo
                    userId
                    userLogin
                    size
                    totalStorageBytes
                    storageLastUpdated
                    isVideo
                    hasVideo
                    hasAudio
                    hasChat
                    hasFiles
                    hasScreenSharing
                    hasAnalysis
                    exportComment
                    errorMessage
                    errorCode
                    policyComparedHit
                    categoryComparedHit
                    scorecardName
                    assessment
                    evaluationKey
                    scenarioId
                    ttl
                    notExportedReason
                    linkedUser
        	        {
                      id
                      name
                    }
                }
            }
            entry {
                callStartMs
                day
                timein
                conversationId
                day
                id
                topic
                recordingType
                speech2Text
                duration
                timeout
                notes
                mediaAssets
                mediaAssetVideo
                userId
                userLogin
                size
                totalStorageBytes
                storageLastUpdated
                isVideo
                hasVideo
                hasAudio
                hasChat
                hasFiles
                hasScreenSharing
                hasAnalysis
                exportComment
                errorMessage
                errorCode
                policyComparedHit
                categoryComparedHit
                scorecardName
                assessment
                evaluationKey
                scenarioId
                ttl
                notExportedReason
                linkedUser
        	    {
                  id
                  name
                }
                integrationName
                incidents{
                    caseId
                    caseName
                    status
                    riskRating
                    creationDate
                    statusChangedDate
                    statusChangedUserName
                }
            }
            lossEntry {
                callStart
                callStartMs
                day
                timein
                conversationId
                day
                id
                topic
                userId
                botAppId
                scenarioId
                tenantId
                callId
                recordingType
                duration
                errorText
                conversationRecorded
                lossType
                participantCount
                userLogin
                integrationName
            }
            caseInfos{
                caseName
                caseStatus
                reviewers
                reviewersName
                creationDate
                statusChangedDate
                statusChangedUserId
                statusChangedUserName
                result
                additionalInfo
                ownerId
                ownerName
            }
          }
        }
    `}
            fetchPolicy="no-cache"
            variables={{ input, project }} >
            {({ loading, error, data }) => {
                if (loading) return <Modal


                    isOpen={this.state.loading}
                >
                    <div style={{
                        borderStyle: "solid",
                        borderColor: "blue",
                        background: "transparent",
                        padding: "20px"
                    }}>
                        <MyContext.Consumer>
                            {(context) => (
                                <Spinner label={context.getTranslation("common", "loadingReportList")} />
                            )
                            }
                        </MyContext.Consumer>
                    </div>


                </Modal>;
                if (error) { toast.error("Error loading report list,\n please check your connection "); return <h1> </h1> };

                if (data?.getReportDetails?.lossEntry != null) {
                    return (
                        <Panel
                            isOpen={this.state.isPanelOpen}
                            onDismiss={this.hidePanel}
                            isFooterAtBottom={false}
                            headerText=""
                            type={PanelType.smallFluid}>
                            <LossDetailContainer authorization={this.props.authorization} apol={apol} data={data.getReportDetails} userRules={this.props.userRules} theme={this.props.theme} hasEntryListDownload={this.props.hasEntryListDownload} isManager={this.props.isManager} isOwner={this.props.isOwner} />
                        </Panel>
                    )
                } else if (data?.getReportDetails?.dtmfEntries !== null) {
                    return (
                        <Panel
                            isOpen={this.state.isPanelOpen}
                            onDismiss={this.hidePanel}
                            isFooterAtBottom={false}
                            headerText=""
                            type={PanelType.smallFluid}>
                            <ReportDtmfContainer authorization={this.props.authorization} apol={apol} data={data.getReportDetails} userRules={this.props.userRules} theme={this.props.theme} />
                        </Panel>
                    )
                } else if (data?.getReportDetails?.caseInfos !== null) {
                    return (
                        <Panel
                            isOpen={this.state.isPanelOpen}
                            onDismiss={this.hidePanel}
                            isFooterAtBottom={false}
                            headerText=""
                            type={PanelType.smallFluid}>
                            <CaseManagementContainer data={data.getReportDetails} />
                        </Panel>
                    )
                }
                else if (data?.getReportDetails?.auditEvents == null && data?.getReportDetails?.kpi === "UserCheck") {
                    return (
                        <Panel
                            isOpen={this.state.isPanelOpen}
                            onDismiss={this.hidePanel}
                            isFooterAtBottom={false}
                            headerText=""
                            type={PanelType.smallFluid}>
                            <ReportUserContainer authorization={this.props.authorization} apol={apol} data={data.getReportDetails} isGrouped={data.getReportDetails.groupedEntries != null && data.getReportDetails.groupedEntries.length > 0} userRules={this.props.userRules} theme={this.props.theme} hasEntryListDownload={this.props.hasEntryListDownload} isManager={this.props.isManager} isOwner={this.props.isOwner} />
                        </Panel>
                    )
                } else if (data?.getReportDetails?.auditEvents == null) {
                    return (
                        <Panel
                            isOpen={this.state.isPanelOpen}
                            onDismiss={this.hidePanel}
                            isFooterAtBottom={false}
                            headerText=""
                            type={PanelType.smallFluid}>
                            <ReportDetailContainer authorization={this.props.authorization} apol={apol} data={data.getReportDetails} isGrouped={data.getReportDetails.groupedEntries != null && data.getReportDetails.groupedEntries.length > 0} userRules={this.props.userRules} theme={this.props.theme} hasEntryListDownload={this.props.hasEntryListDownload} isManager={this.props.isManager} isOwner={this.props.isOwner} />
                        </Panel>
                    )
                } else {
                    return (
                        <Panel
                            isOpen={this.state.isPanelOpen}
                            onDismiss={this.hidePanel}
                            isFooterAtBottom={false}
                            headerText=""
                            type={PanelType.smallFluid}>
                            <AuditDetailContainer authorization={this.props.authorization} apol={apol} data={data.getReportDetails} userRules={this.props.userRules} theme={this.props.theme} hasEntryListDownload={this.props.hasEntryListDownload} isManager={this.props.isManager} isOwner={this.props.isOwner} />
                        </Panel>
                    )
                }
            }}
        </Query>
    );

    showPanel = (id) => {
        this.setState({ isPanelOpen: true, id: id });
    };

    hidePanel = () => {
        this.setState({ isPanelOpen: false, id: null });
    };

    render() {
        // console.log("ReportView render", this.state);
        return (
            <ApolloProvider client={this.props.apol}>
                {this.state.id
                    ? this.renderData(this.props.authorization, this.state.id, this.props.apol)
                    : null}
            </ApolloProvider>
        );
    }
}
